import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { Map } from 'immutable';
import { Title } from '../layout';
import { LoadingPane, PagedList, pagedListUtilities, SearchableDropdown } from '../common';
import { bindActionCreators } from 'redux';
import * as intakeFormsActions from './intake-forms.actions';
import * as modifyIntakeActions from './modify-intake-form/modify-intake-form.actions';
import * as sitesActions from '../permissions/touchpoint/site-list-folder/site-list.actions';
import AddFormModal from './add-form';
import './intake-forms.scss';

export class IntakeFormsComponent extends Component {

  componentDidMount() {
    const { intakeFormsActions, modifyIntakeActions, sitesActions } = this.props;
    const { fetchCompleteSiteList } = sitesActions || {};
    const { fetchIntakeForms } = intakeFormsActions || {};
    const { preserveEdits, clearPreviewState } = modifyIntakeActions || {};

    fetchCompleteSiteList();
    fetchIntakeForms();

    // should never have intake form edits stored if on this component
    preserveEdits(false);
    clearPreviewState();
  }


  componentDidUpdate(prevProps, prevState) {
    const { intake: prevIntake } = prevProps;
    const { showSelectSiteModal: prevShowSelectSite } = (prevIntake && prevIntake.create) || {};;
    const { intake, intakeFormsActions, modifyIntakeActions } = this.props;
    const { showSelectSiteModal } = (intake && intake.create);
    const { fetchIntakeForms } = intakeFormsActions || {};
    const { preserveEdits, clearPreviewState } = modifyIntakeActions || {};

    fetchIntakeForms();

    // should never have intake form edits stored if on this component
    preserveEdits(false);
    clearPreviewState();

    if (!prevShowSelectSite && !!showSelectSiteModal) {
      var modalFocusTarget = document.getElementById('modal');
      if (modalFocusTarget) modalFocusTarget.focus();
    }
  }


  /**
   * Function that executes when the user selects the site on the add intake modal
   * @param {Guid} selectedSite : the Guid of the site of which to create the intake form
   */
  handleUpdateSite(selectedSiteId) {
    const { sitesActions, intakeFormsActions, sites } = this.props;
    const { setSelectedSite } = intakeFormsActions || {};
    const { fetchProgramsForSite } = sitesActions || {};
    const { siteListState } = sites || {};
    const siteData = siteListState && siteListState.data && siteListState.data.results;
    const siteIndex = siteData && siteData.findIndex(res => res.id === selectedSiteId);
    const selectedSite = siteData && siteData[siteIndex];
    const selectedSiteProgramsValid = selectedSite && selectedSite.isValid;
    setSelectedSite(selectedSiteId);
    if (!selectedSiteProgramsValid) fetchProgramsForSite(selectedSiteId);
  }

  /**
   * Function that executes when the user selects the program on the add intake modal
   * @param {Guid} selectedProgramId : the Guid of the program of which to create the intake form
   */
  handleUpdateProgram(selectedProgramId) {
    const { intakeFormsActions } = this.props;
    const { setSelectedProgram } = intakeFormsActions || {};

    setSelectedProgram(selectedProgramId);
  }

  /**
   * Function makes the new intake form modal visible
   */
  showAddFormModal() {
    const { intakeFormsActions } = this.props;
    const { showSelectSiteModalVisible } = intakeFormsActions;

    showSelectSiteModalVisible();
  }

  /**
   * Function closes the new intake form modal
   */
  closeAddFormModal() {
    const { intakeFormsActions } = this.props;
    const { closeSelectSiteModalVisible } = intakeFormsActions;

    closeSelectSiteModalVisible();
  }

  /**
   * The function that executes when the user chooses their site and programs then clicks OK.
   */
  createIntakeForm() {
    const { intake, intakeFormsActions, redirectTo } = this.props;
    const { currentSelectedSite, currentSelectedProgram } = (intake && intake.create) || {};

    redirectTo(`/intake-forms/create/${currentSelectedSite}/${currentSelectedProgram}`);
    intakeFormsActions.confirmSelection();
  }

  handleEdit(id) {
    const { redirectTo } = this.props;
    redirectTo(`/intake-forms/edit/${id}`);
  }

  handlePreview(id) {
    const { redirectTo } = this.props;
    redirectTo(`/intake-forms/preview/${id}`);
  }

  handlePublish(id) {
    const { redirectTo } = this.props;
    redirectTo(`/intake-forms/publish/${id}`);
  }

  renderIntakeForm(intakeForm) {
    if(!intakeForm) {
      return <tr/>;
    }

    var touchpointDisplay = '';
    !!intakeForm.touchpointNames && intakeForm.touchpointNames.forEach((name, index) => {
      if(index > 0)
        touchpointDisplay += ', '
      touchpointDisplay += name;
    });

    var publishIconClass = 'glyphicon glyphicon-upload';
    var publishTitle = 'Publish';
    if(intakeForm.isPublished) {
      publishIconClass = 'glyphicon glyphicon-resize-small';
      publishTitle = 'Retract';
    }

    return (
      <tr>
        <td>{intakeForm.name}</td>
        <td>{intakeForm.siteName}</td>
        <td>{intakeForm.programName}</td>
        <td>{touchpointDisplay}</td>
        <td>
          <button
            className='btn btn-primary action-btn'
            title='Edit'
            aria-label='Edit'
            onClick={e => this.handleEdit(intakeForm.id)}>
            <span className="glyphicon glyphicon-pencil"/>
          </button>
          <button
            className='btn btn-primary action-btn'
            title='Preview'
            aria-label='Preview'
            onClick={e => this.handlePreview(intakeForm.id)}>
            <span className="glyphicon glyphicon-eye-open"/>
          </button>
          <button
            className='btn btn-primary action-btn'
            title={publishTitle}
            aria-label={publishTitle}
            onClick={e => this.handlePublish(intakeForm.id)}>
            <span className={publishIconClass}/>
          </button>
        </td>
        <td>{intakeForm.isPublished ? "Published" : null}</td>
      </tr>
    )
  }

  render() {
    const { intake, sites, intakeFormsActions } = this.props;
    const { changeSort, setFilterSite } = intakeFormsActions;
    const { create, intakeForms, pagingData, filterSite } = intake;
    const { isFetching, err, data } = intakeForms
    const { sortBy, sortAsc } = pagingData || {};
    const { showSelectSiteModal, currentSelectedSite, currentSelectedProgram } = create || {};
    const { siteListState, programLists } = sites || {};
    const { isFetching: isFetchingSites, data: pagedSites } = siteListState || {};
    const siteData = pagedSites && pagedSites.results;
    const siteList = [{ value : null, label : '--Select--'}];
    !!siteData && siteData.forEach(site => {  siteList.push({ value: site.id, label: site.name })});

    var programsState = currentSelectedSite && programLists && programLists.get(currentSelectedSite);

    var pagedListProps = pagedListUtilities.getPagedListProps(intakeForms, pagingData, intakeFormsActions);
    var loadingMessage = "Loading Intake Forms...";
    const perPageOptions = [
      { value : 5, label : '5' },
      { value : 10, label : '10'},
      { value : 25, label : '25'},
      { value : 50, label : '50'}
    ];

    const headerNames = new Map({
      name : {
        displayName: 'FORM NAME',
        dataType: 'alpha'
      },
      site : {
        displayName: 'SITE',
        dataType: 'alpha'
      },
      program : {
        displayName: 'PROGRAM',
        dataType: 'alpha'
      },
      touchpoint : {
        displayName: 'TOUCHPOINT',
        dataType: 'alpha'
      }
    });

    const sortText =  pagedListUtilities.getSortText(headerNames, sortBy, sortAsc);
    const sortMessage = "Intake Forms sorted by " + sortText;
    const contentLoadedMessage = "Content Loaded. " + sortMessage;
    const headerColumns = pagedListUtilities.buildSortHeader(headerNames, sortBy, sortAsc, changeSort);

    const headers = (
      <tr>
        {headerColumns}
        <th>ACTIONS</th>
        <th>STATUS</th>
      </tr>
    );

    return (
      <div id='intake-forms'>
        <Title title="Intake Forms" />

        <h1>Intake Forms</h1>
        <h5>Manage intake forms for your enterprise.</h5>
        <button className="btn btn-primary"
          onClick={e => this.showAddFormModal()}>
          Add Form
        </button>
        {/* modal for selecting site and program for starting a new intake form  */}
        <AddFormModal
          show={showSelectSiteModal}
          siteState={siteListState}
          currentSelectedSite={currentSelectedSite}
          handleUpdateSite={(value) => this.handleUpdateSite(value)}
          programState={programsState}
          currentSelectedProgram={currentSelectedProgram}
          handleUpdateProgram={(value) => this.handleUpdateProgram(value)}
          onClose={e => this.closeAddFormModal()}
          onSave={e => this.createIntakeForm()} />
        <LoadingPane
          isLoading={isFetching && !data}
          err={err}
          loadingMessage={loadingMessage}>
          <div className="intake-filter">
            <div className="intake-filter-label">
              <label htmlFor="site-filter-dropdown-id" className="label-override">Site</label>
            </div>
            <div className="intake-filter-dropdown">
              <SearchableDropdown
                id="site-filter-dropdown-id"
                instanceId="1"
                name="site-filter-dropdown"
                options={siteList}
                value={filterSite || ""}
                isLoading={isFetchingSites}
                onChange={newValue => setFilterSite(newValue.value)}
                autoFocus={true}/>
            </div>
          </div>
          <PagedList
            header={headers}
            mapItem={form => this.renderIntakeForm(form)}
            emptyMessage={"no intake forms found"}
            loadingMessage={loadingMessage}
            contentLoadedMessage={contentLoadedMessage}
            variableResultsPerPage={true}
            perPageOptions={perPageOptions}
            {...pagedListProps}/>
        </LoadingPane>
      </div>
    );
  }
}

IntakeFormsComponent.propTypes = {
  intake: PropTypes.shape({
    create: PropTypes.shape({
      showSelectSiteModal: PropTypes.bool,
      currentSelectedSite: PropTypes.string,
    }),
  }),
};

const mapStateToProps = ({ intake, sites }) => {
  return {
    intake,
    sites
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    intakeFormsActions: bindActionCreators(intakeFormsActions, dispatch),
    modifyIntakeActions: bindActionCreators(modifyIntakeActions, dispatch),
    sitesActions: bindActionCreators(sitesActions, dispatch),
    redirectTo: bindActionCreators(push, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(IntakeFormsComponent);
